import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { Redirect, useParams } from 'react-router-dom';
import MetaLayout from '€layouts/MetaLayout';
import PreAuthLayout from '€layouts/PreAuthLayout';
import {
    getSignUpSuccess,
    getSignUpTokenData,
    getSignUpTokenValidationState,
    validateRegistrationToken,
} from '€slices/sign-up';
import SignUpInvalid from '€components/SignUpInvalid';
import ContentLayout from '€layouts/ContentLayout';
import CenterSmUp from '€components/CenterSmUp';
import SignUpForm from '€components/SignUpForm';
import { RequestState } from '~/src/types/RequestState';
import { Routes } from '€lib/routing';

const SignUp = () => {
    const dispatch = useDispatch();
    const validationState = useSelector(getSignUpTokenValidationState);
    const tokenData = useSelector(getSignUpTokenData);
    const { token } = useParams<{ token?: string }>();
    const signupSuccess = useSelector(getSignUpSuccess);

    useEffect(() => {
        dispatch(validateRegistrationToken(token));
    }, []);

    return (
        <MetaLayout metaTitle="Loan | Sign Up">
            <PreAuthLayout title="Set a password">
                {signupSuccess && <Redirect to={Routes.Dashboard} />}
                {tokenData && (
                    <>
                        <ContentLayout.Section>
                            <CenterSmUp>
                                <Typography color="textSecondary">
                                    Your password should be at least 8 characters long.
                                </Typography>
                            </CenterSmUp>
                        </ContentLayout.Section>
                        <SignUpForm token={token} email={tokenData.email} />
                    </>
                )}
                {validationState === RequestState.Error && <SignUpInvalid />}
            </PreAuthLayout>
        </MetaLayout>
    );
};

export default SignUp;
